<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useChatStore } from '../stores/chatStore';

const chatStore = useChatStore();
const { t } = useI18n();

const history = computed(() => chatStore.followUpHistory.filter((task) => task.status === 'success'));

const formatDate = (value?: string) => {
  if (!value) {
    return '';
  }

  try {
    return new Date(value).toLocaleString(chatStore.language);
  } catch (error) {
    return value;
  }
};
</script>

<template>
  <div class="h-full overflow-y-auto px-4 py-6 space-y-6 bg-gray-50">
    <section>
      <h3 class="text-sm font-semibold mb-3" :class="chatStore.createLanguageClass(chatStore.language)">
        {{ t('followUpHistoryHeading') }}
      </h3>
      <p v-if="!history.length" class="text-xs text-gray-500" :class="chatStore.createLanguageClass(chatStore.language)">
        {{ t('followUpHistoryEmpty') }}
      </p>
      <ul v-else class="space-y-3">
        <li v-for="task in history" :key="task.id" class="bg-white border border-gray-200 rounded-lg shadow-sm p-3">
          <p class="text-sm font-medium" :class="chatStore.createLanguageClass(chatStore.language)">{{ task.question }}</p>
          <div class="text-xs text-gray-700 mt-2 leading-relaxed" :class="chatStore.createLanguageClass(chatStore.language)"
            v-html="task.responseHtml" />
          <p v-if="task.completedAt" class="text-[11px] text-gray-400 mt-2">
            {{ formatDate(task.completedAt) }}
          </p>
        </li>
      </ul>
    </section>

    <section>
      <h3 class="text-sm font-semibold mb-3" :class="chatStore.createLanguageClass(chatStore.language)">
        {{ t('followUpSummaryHeading') }}
      </h3>
      <p v-if="!chatStore.followUpSummary" class="text-xs text-gray-500"
        :class="chatStore.createLanguageClass(chatStore.language)">
        {{ t('followUpSummaryEmpty') }}
      </p>
      <div v-else class="text-xs text-gray-700 whitespace-pre-line"
        :class="chatStore.createLanguageClass(chatStore.language)">
        {{ chatStore.followUpSummary }}
      </div>
    </section>
  </div>
</template>

<style scoped>
@reference "../assets/css/tailwind.css";
</style>
